// 图片懒加载指令
import { Directive } from 'vue';

// 定义懒加载指令
const lazyLoad: Directive = {
  mounted(el, binding) {
    // 创建 Intersection Observer 实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 图片进入视口，加载图片
          const img = entry.target as HTMLImageElement;
          img.src = binding.value;
          // 加载完成后停止观察
          observer.unobserve(img);
        }
      });
    }, {
      // 可选配置：图片进入视口 10% 时开始加载
      threshold: 0.1
    });

    // 观察目标元素
    observer.observe(el);

    // 保存 observer 实例，便于组件卸载时清理
    (el as any).__lazyLoadObserver__ = observer;
  },
  unmounted(el) {
    // 组件卸载时清理 observer
    const observer = (el as any).__lazyLoadObserver__;
    if (observer) {
      observer.disconnect();
    }
  }
};

export default lazyLoad;